export default "__VITE_ASSET__DRvJlNTg__"